export const DELETE_PROFILE_SUCCESS = "DELETE_PROFILE_SUCCESS";
export const DELETE_PROFILE_REQUEST = "DELETE_PROFILE_REQUEST";
